import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { queryFn } from './queryFn';

/**
 * This hook returns the statements for the given company,
 * You can optionally specify which statement names to filter by
 */
export const useCompanyStatements = ({
  canonicalURL,
  names,
  options,
}: {
  canonicalURL: string;
  names?: string[];
  options?: Pick<UseQueryOptions, 'staleTime'>;
}) => {
  return useQuery({
    queryKey: ['COMPANY_STATEMENTS', canonicalURL, names],
    queryFn,
    ...options,
  });
};
